"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SettingsButton = exports.DenyButton = exports.BannerWrapper = exports.BannerTitle = exports.BannerDescription = exports.BannerActions = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const colors_1 = require("../../../../assets/styles/colors");
const Modals_style_1 = require("../Modals.style");
const BannerWrapper = styled_components_1.default.div `
  position: fixed;
  bottom: 3.2rem;
  left: 50%;
  transform: translateX(-50%);
  background: ${colors_1.white};
  border-radius: 1.2rem;
  box-shadow: 0 0.2rem 1.6rem rgba(0, 0, 0, 0.12);
  padding: 2rem 2.5rem;
  z-index: 1000;
  min-width: 34rem;
  max-width: 30vw;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;
exports.BannerWrapper = BannerWrapper;
const BannerTitle = styled_components_1.default.h2 `
  color: ${colors_1.acBlue};
  font-size: 1.6rem;
  margin-bottom: 1.6rem;
  text-transform: uppercase;
  align-self: center;
`;
exports.BannerTitle = BannerTitle;
const BannerDescription = styled_components_1.default.p `
  color: ${colors_1.gray300};
  font-size: 1.2rem;
  line-height: 1.5;
  word-wrap: break-word;
  word-break: break-word;
  hyphens: auto;
  text-align: left;
  margin-bottom: 1.5rem;
`;
exports.BannerDescription = BannerDescription;
const BannerActions = styled_components_1.default.div `
  display: flex;
  gap: 1rem;
  width: 100%;
  justify-content: center;
`;
exports.BannerActions = BannerActions;
const DenyButton = (0, styled_components_1.default)(Modals_style_1.BlueButton) `
  background: ${colors_1.gray100};
  color: ${colors_1.gray300};
  border: none;
`;
exports.DenyButton = DenyButton;
const SettingsButton = (0, styled_components_1.default)(Modals_style_1.BlueButton) `
  background: ${colors_1.white};
  color: ${colors_1.gray400};
  border: none;
`;
exports.SettingsButton = SettingsButton;
